import { useContext } from 'react';
import { AuthContext } from 'providers/AuthProvider';
import type { AuthContextProps } from 'providers/AuthProvider';

export function useAuth(): AuthContextProps {
  return useContext(AuthContext);
}
